$('.variant_image').each(function() {
    // var srcimg = $(this).data('src');
    $('.variant_image_to[data-place="' + $(this).data('place') + '"]').attr( "src" , $(this).data('src') );
   // $('.variant_image_to[data-place="' + $(this).data('place') + '"]').attr( "alt" , $(this).data('alt') );
    $('.swatch_set[data-place="' + $(this).data('place') + '"]').attr( "data-inventory" , $(this).data('inventory') );
    $('.swatch_set[data-place="' + $(this).data('place') + '"]').attr( "data-moq" , $(this).data('moq') );
    });
    // $( "input.pick-option" ).on( "click", function() {
    // $( ".variant_onchange" ).html( $( "input:checked" ).val() );
    // });
    $("input.pick-option").on("click", function() {
        let selectedColor = $("input.pick-option:checked").data("color");
        if (selectedColor) {
            $(".variant_onchange").html(`${selectedColor}`);
        } else {
            $(".variant_onchange").html("Unavailable");
        }
    });
    $("#footer-menu li:last").after('<li class="cookies_prefrences"><button onclick="showPreferences(this);" class="isense-reopen-widget-link link link--text list-menu__item list-menu__item--link" aria-haspopup="dialog" style="cursor: pointer;">Cookie Preferences</button></li>');
    $( ".mega-content h3:contains('Popular Hat Brands')" ).prepend('<span aria-hidden="true" class="hot_prod"><img src="https://cdn.shopify.com/s/files/1/0818/5613/5441/files/fire.png?v=1702548277" alt=""></span>');
    //Accessibility Improvments for Klaviyo form 
    $(document).ready(function() {
        $(document).on('click', '.go338491780', function(event) {
            setTimeout(function() {
                $('.needsclick>form').focus();
            }, 2000);
        });
    });
    // Scroll up to fix header
    $(document).ready(function() {
        var lastScroll = 0;
        $(window).on('scroll', function() {    
            var scroll = $(window).scrollTop();
            var isMegaMenuOpen = $('.mega-menu[open]').length > 0;
    
            // Calculate the total document height
            var documentHeight = $(document).height();
    
            // Calculate the window height
            var windowHeight = $(window).height();
    
            // Calculate the scrolled percentage
            var scrollPercentage = (scroll / (documentHeight - windowHeight)) * 100;
    
            if (lastScroll - scroll > 0 && scroll >= 200) {
                // Scrolling up and past 200px, add fixedheader class
                $(".freeze_header").addClass("freezed");
            } else if (!isMegaMenuOpen && scrollPercentage < 95) {
                // Scrolling down, mega-menu is not open, and scroll is less than 95%, remove fixedheader class
                $(".freeze_header").removeClass("freezed");
            }
    
            lastScroll = scroll;
        });
    });
    
    // Accessibility for target blank anchor
    $(document).ready(function () {
        $('br').attr('aria-hidden', 'true');
        $('a').filter('[target="_blank"]').append('<span class="visually-hidden" style="color:black;background:white;">(opens new window)</span>');
    });
    // Mobile Menu
    $(document).ready(function () {
        const menuButton = $("#menubutton");
        const mainMenu = $("#mainmenu");
        const closeButton = $(".closeMenu");
    
        function checkWindowWidth() {
            if ($(window).width() <= 1000) {
                mainMenu
                    .attr('tabindex', '-1')
                    .attr('role', 'dialog')
                    .attr('aria-modal', 'true')
                    .attr('aria-label', 'Star hats & embroidery Mobile Menu');
    
                $('.skip__nav').attr('href', '#menubutton');
    
                // Unbind previous events to avoid duplication
                $(document).off("click.menu");
    
                $(document).on("click.menu", function (event) {
                    if (
                        mainMenu.is(':visible') &&
                        !mainMenu.is(event.target) &&
                        !menuButton.is(event.target) &&
                        mainMenu.has(event.target).length === 0
                    ) {
                        closeMenu();
                    }
                });
            } else {
                // Unbind event when screen width is greater than 1000px
                $(document).off("click.menu");
            }
        }
    
        function openMenu() {
            mainMenu.show();
            $('body').addClass('mobile-menu-open');
            mainMenu.focus();
        }
    
        function closeMenu() {
            mainMenu.hide();
            $('body').removeClass('mobile-menu-open');
        
            // Ensure menuButton is focusable before setting focus
            menuButton.attr('tabindex', '0').focus();
        
            // Delay focus slightly to ensure VoiceOver recognizes the focus change
            setTimeout(() => {
                menuButton.focus();
            }, 100);
        }
    
        // Initial check
        checkWindowWidth();
    
        // Re-check when resizing
        $(window).on("resize", function () {
            checkWindowWidth();
            if ($(window).width() > 1000) {
                closeMenu(); // Ensure menu is closed when resizing to desktop
            }
        });
    
        // Toggle menu on button click
        menuButton.on("click", function (event) {
            if (mainMenu.is(':visible')) {
                closeMenu();
            } else {
                openMenu();
            }
            event.stopPropagation();
        });
    
        // Close menu when clicking the close button
        closeButton.on("click", closeMenu);
    });
    
    document.addEventListener("DOMContentLoaded", function () {
        if (window.innerWidth > 990) { // Adjust breakpoint as needed
            const mobileMenu = document.querySelector('#menubuttonskip');
            if (mobileMenu) {
                mobileMenu.remove(); // Remove the element
            }
        }
    });
    document.getElementById('copyCoupon').addEventListener('click', function() {
        // Retrieve text from the element with ID 'couponcode'
        const couponElement = document.getElementById('couponcode');
        const textToCopy = couponElement.textContent || couponElement.value; // This line handles both text content and input value
    
        // Copy text to clipboard
        navigator.clipboard.writeText(textToCopy).then(() => {
            console.log('Text copied to clipboard');
    
            // Update and show the message
            const messageElement = document.getElementById('clipboard_message');
            messageElement.textContent = "Code copied, please paste on the checkout page";
            messageElement.style.display = 'block';
    
            // Hide the message after 3 seconds
            setTimeout(function() {
                messageElement.textContent = '';
                messageElement.style.display = 'none';
            }, 3000); // Corrected to match the actual timeout duration
        }).catch(err => {
            console.error('Error in copying text: ', err);
        });
    });
    // This Function is for Powerfull form builder App, to make custom form accessible.
  $(document).ready(function() {
    // Function to add aria attributes to messages
    function addAriaAttributes() {
        $('.message.success, .message.error').attr({
            'aria-atomic': 'true',
            'aria-live': 'polite'
        });
    }

    // Function to insert the message after the submit action
    function insertMessage() {
        const wizardHeader = document.querySelector('.action.submit');
        if (wizardHeader) {
            const messageDiv = document.createElement('div');
            messageDiv.className = 'missing_req-fields';
            messageDiv.setAttribute('aria-atomic', 'true');
            messageDiv.setAttribute('aria-live', 'polite');
            messageDiv.textContent = 'The form has not been submitted because some required fields are missing. Please return to the top of the form and fill in each required field sequentially to submit the form.';
            
            wizardHeader.after(messageDiv);
            
            setTimeout(() => {
                messageDiv.style.display = 'none';
            }, 10000);
        }
    }

    // Observe changes in the document body and the target form
    function observeChanges() {
        const config = { attributes: true, childList: true, subtree: true };
        const observerCallback = function(mutationsList, observer) {
            mutationsList.forEach(mutation => {
                if (mutation.type === 'childList' && $('.globo-formbuilder').length) {
                    addAriaAttributes();
                }
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (target.classList.contains('panel') && target.classList.contains('errors')) {
                        observer.disconnect(); // Optionally, disconnect to avoid unnecessary operations
                        insertMessage();
                    }
                }
            });
        };
        const observer = new MutationObserver(observerCallback);
        observer.observe(document.body, config);

        // Reconnect observer on submit button click to monitor form submission status
        const submitButton = document.querySelector('[type="submit"]');
        if (submitButton) {
            submitButton.addEventListener('click', () => {
                observer.observe(document.body, config);
            });
        }
    }
    
    // Initialize observation and functionality
    observeChanges();
});
// This Function to run when the Wholesale Product table is loaded
// Function to manipulate the table and update the volume price
function onTableLoaded() {
    var lastRow = $('#wsaio-volume-discount--table tr:last-child'); // Get the last row of the table
    var tdWithDollar = lastRow.find('td').filter(function() {
        return $(this).text().includes('$'); // Find the first <td> that contains a dollar sign
    }).first(); // Use .first() to get the first match

    if (tdWithDollar.length) {
        var textParts = tdWithDollar.text().split(' '); // Split the text to get the dollar amount
        var textToCopy = textParts[0]; // Get the dollar value (e.g., $10.00)
        var htmlContent = '<div class="volume_price_inner">As low as <span class="as_low">' + textToCopy + '</span> when you purchase in volume!</div>';
        $('.volume_price').html(htmlContent); // Update the .volume_price element with the new content
    } else {
        console.log('No <td> with a dollar sign found in the last row.');
    }

    // Check if the table exists and show/hide the .buy-more-set div
    var tableExists = $('#wsaio-volume-discount--table').length > 0; // Check if the table exists
    if (tableExists) {
        $('.buy-more-set').show(); // Show the banner if the table exists
    } else {
        $('.buy-more-set').hide(); // Hide the banner if no table is found
    }
}

// Find the specific parent container (.product__info-wrapper) that contains the table
var parentContainer = document.querySelector('.product__info-wrapper');

// MutationObserver setup
var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (!mutation.addedNodes) return;

        for (var i = 0; i < mutation.addedNodes.length; i++) {
            // Check if the added node is the table we're interested in
            var node = mutation.addedNodes[i];
            if (typeof node.id !== 'undefined' && node.id === 'wsaio-volume-discount--table') {
                onTableLoaded(); // Run the function to process the table
                observer.disconnect(); // Stop observing since we've processed the table
                break;
            }
        }
    });
});

// Observer options - observe the added nodes within the specific parent container
var config = {
    childList: true,
    subtree: true
};

// Start observing the specific parent container (.product__info-wrapper)
if (parentContainer) {
    observer.observe(parentContainer, config);
} else {
    console.log('.product__info-wrapper not found.');
}

// Initially check if the table exists and hide/show the .buy-more-set div
onTableLoaded();

// Code for Prop 65 Warnings 
$(document).ready(function() {
    $('.prop-warning-btn').on('click', function() {
      // Toggle open class on the button
      $(this).toggleClass('open');
      // Toggle open class on the associated content
      $('.prop-warning-content').toggleClass('open');
  
      // Check current aria-expanded value and toggle it
      var isExpanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !isExpanded);
  
      // Optionally, also toggle aria-expanded for the content if needed
      // $('.prop-warning-content').attr('aria-expanded', !isExpanded);
    });
  });
  $(document).ready(function() {
   // Select all elements with aria-hidden="true"
   $('[aria-hidden="true"]').each(function() {
    // Check if the current element is not an SVG
    if (!$(this).is('svg')) {
        // Add tabindex="-1" to the element
        $(this).attr('tabindex', '-1');
    }
});
});
document.addEventListener("DOMContentLoaded", function() {
    // Check if the success message exists
    var successMessage = document.getElementById("success-message");
    if (successMessage) {
      // Wait for 1 second before setting the focus
      setTimeout(function() {
        successMessage.focus();
      }, 2000);
    }
  });
$(document).ready(function() {
    $('#transcript-btn').on('click', function() {
        setTimeout(function() {
            $('#accordion-video-trancript').focus();
        }, 2000); // 2000 milliseconds = 2 seconds
    });
});
// $(document).ready(function() {
//     // Check if the browser supports voice recognition
//     if ('webkitSpeechRecognition' in window) {
//         const recognition = new webkitSpeechRecognition();
//         recognition.continuous = false;
//         recognition.interimResults = false;
//         recognition.lang = 'en-US';

//         $('#voice-search-btn').on('click', function() {
//             recognition.start(); // Start voice recognition
//             $(this).addClass('voice-activate');
//         });

//         recognition.onresult = function(event) {
//             const query = event.results[0][0].transcript;
//             $('#search-input').val(query);

//             // Redirect to search page with voice query
//             window.location.href = `/search?q=${query}`;
//         };

//         recognition.onerror = function(event) {
//             alert('Voice search error: ' + event.error);
//         };
//     } else {
//         alert('Your browser does not support voice search');
//     }
// });
document.addEventListener("DOMContentLoaded", function() {
    var originalTitle = document.title; // Store the original title
    var attentionTitle = "🔥 Great prices on custom orders!"; // The attention-grabbing title
    var titleSwitcher;
  
    // When the user leaves the tab (blur event)
    window.addEventListener("blur", function() {
      // Start switching the title every 1 second
      titleSwitcher = setInterval(function() {
        document.title = (document.title === originalTitle) ? attentionTitle : originalTitle;
      }, 1000);
    });
  
    // When the user returns to the tab (focus event)
    window.addEventListener("focus", function() {
      clearInterval(titleSwitcher); // Stop switching the title when the tab is focused
      document.title = originalTitle; // Revert to the original title
    });
  });
    // free shipping bar
document.addEventListener("DOMContentLoaded", function () {
  // ===== CONFIG (use cents) =====
  const freeShippingThresholdCents = 19500; // $195.00 milestone
  const minimumCartValueCents = 15000;       // $50.00 (hide bar below this)
  let lastCartTotalCents = null;

  // Use your shop format if available (keeps remaining amount formatting correct)
  const moneyFormat =
    (window.theme && window.theme.moneyFormat) ||
    (window.Shopify && window.Shopify.money_format) ||
    "${{amount}}";

  // Goal (milestone) should NOT show decimals
  const moneyFormatNoDecimals = "${{amount_no_decimals}}";

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function formatMoneyNoDecimals(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormatNoDecimals);
    }
    return `$${Math.round(cents / 100)}`;
  }

  function getNodes() {
    return {
      bar: document.getElementById("free-shipping-bar"),
      shippingMessage: document.getElementById("shipping-message"),
      progressBar: document.getElementById("progress-bar"),
      shipbarGoal: document.getElementById("shipbar-goal"), // right-side milestone label
    };
  }

  function throttle(fn, wait) {
    let timeoutId = null;
    let lastCallTime = 0;
    let lastArgs, lastThis;

    return function throttled(...args) {
      const now = Date.now();
      const remaining = wait - (now - lastCallTime);

      lastArgs = args;
      lastThis = this;

      if (remaining <= 0) {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = null;
        lastCallTime = now;
        fn.apply(lastThis, lastArgs);
      } else if (!timeoutId) {
        timeoutId = setTimeout(() => {
          lastCallTime = Date.now();
          timeoutId = null;
          fn.apply(lastThis, lastArgs);
        }, remaining);
      }
    };
  }

  function updateFreeShippingBar() {
    const { bar, shippingMessage, progressBar, shipbarGoal } = getNodes();
    if (!bar || !shippingMessage || !progressBar || !shipbarGoal) return;

    // Right-side milestone: always show $195 (NO decimals)
    shipbarGoal.textContent = formatMoneyNoDecimals(freeShippingThresholdCents);

    fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then((res) => {
        if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
        return res.json();
      })
      .then((cart) => {
        const cartTotalCents = Number(cart.total_price) || 0;

        // Avoid re-render if unchanged
        if (cartTotalCents === lastCartTotalCents) return;
        lastCartTotalCents = cartTotalCents;

        // Hide under minimum
        if (cartTotalCents < minimumCartValueCents) {
          bar.style.display = "none";
          bar.setAttribute("aria-hidden", "true");
          return;
        }

        const remainingCents = Math.max(freeShippingThresholdCents - cartTotalCents, 0);
        const unlocked = remainingCents === 0;

        const progress = Math.min(
          100,
          (cartTotalCents / freeShippingThresholdCents) * 100
        );

          shippingMessage.innerHTML = unlocked
  ? "🎉 Congrats! You Unlocked FREE SHIPPING!*"
  : `You are <strong class="shipbar-remaining">${formatMoney(remainingCents)}</strong> away from FREE SHIPPING!*`;

        progressBar.style.width = `${progress}%`;
        progressBar.setAttribute("aria-valuenow", String(Math.round(progress)));
        progressBar.classList.toggle("free-shipping-reached", unlocked);

        bar.style.display = "block";
        bar.setAttribute("aria-hidden", "false");
      })
      .catch((err) => console.error("Cart fetch error:", err));
  }

  const throttledUpdate = throttle(updateFreeShippingBar, 800);

  function isCartMutation(url, method) {
    const u = String(url || "");
    const m = String(method || "GET").toUpperCase();

    // Ignore reads (including our own /cart.js fetch)
    if (u.includes("/cart.js")) return false;
    if (m === "GET") return false;

    // React only to mutation endpoints
    return /\/cart\/(add|change|update|clear)(\.js)?/.test(u);
  }

  function monitorCartChanges() {
    // Fetch hook
    if (window.fetch) {
      const originalFetch = window.fetch;

      window.fetch = function (input, init) {
        const url = typeof input === "string" ? input : (input && input.url) || "";
        const method = (init && init.method) || (input && input.method) || "GET";

        return originalFetch.call(this, input, init).then((response) => {
          if (isCartMutation(url, method)) {
            // Run after theme/app DOM updates
            setTimeout(throttledUpdate, 0);
          }
          return response;
        });
      };
    }

    // XHR hook (optional; helps with older themes/apps)
    if (window.XMLHttpRequest) {
      const open = XMLHttpRequest.prototype.open;
      const send = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__cartMethod = method;
        this.__cartUrl = url;
        return open.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        this.addEventListener("load", () => {
          if (isCartMutation(this.__cartUrl, this.__cartMethod)) {
            setTimeout(throttledUpdate, 0);
          }
        });
        return send.apply(this, arguments);
      };
    }

    // Theme/app events
    document.addEventListener("cart:updated", throttledUpdate);
    document.addEventListener("ajaxCart:updated", throttledUpdate);
    document.addEventListener("cart:change", throttledUpdate);

    // Back/forward cache restores
    window.addEventListener("pageshow", throttledUpdate);
  }

  updateFreeShippingBar();
  monitorCartChanges();
});

  
  